export default "__VITE_ASSET__rhEezZhS__"